import { render, staticRenderFns } from "./PurchasePlanDetail.vue?vue&type=template&id=36ba8e5d&scoped=true&"
import script from "./PurchasePlanDetail.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanDetail.vue?vue&type=style&index=0&id=36ba8e5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba8e5d",
  null
  
)

export default component.exports